import React, { createContext, useContext, useMemo, useState } from 'react'
import moment from 'moment'

const AnalyticsFilterContext = createContext()

const defaultEndDate = () => moment().format('YYYY-MM-DD')
const defaultStartDate = () => moment().subtract(29, 'days').format('YYYY-MM-DD')

export const AnalyticsFilterProvider = ({ children }) => {
    const [startDate, setStartDate] = useState(defaultStartDate)
    const [endDate, setEndDate] = useState(defaultEndDate)
    const [workshopId, setWorkshopId] = useState('')
    const [granularity, setGranularity] = useState('day')

    const rangeFilters = useMemo(() => {
        const params = {
            startDate,
            endDate
        }
        if (workshopId) {
            params.workshopId = workshopId
        }
        return params
    }, [startDate, endDate, workshopId])

    const filters = useMemo(
        () => ({
            ...rangeFilters,
            granularity
        }),
        [rangeFilters, granularity]
    )

    const value = {
        startDate,
        setStartDate,
        endDate,
        setEndDate,
        workshopId,
        setWorkshopId,
        granularity,
        setGranularity,
        rangeFilters,
        filters
    }

    return <AnalyticsFilterContext.Provider value={value}>{children}</AnalyticsFilterContext.Provider>
}

export const useAnalyticsFilters = () => {
    const context = useContext(AnalyticsFilterContext)
    if (!context) {
        throw new Error('useAnalyticsFilters must be used within AnalyticsFilterProvider')
    }
    return context
}

export default AnalyticsFilterContext
